
<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <router-view></router-view>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
export default {
  components: {
    Sidebar
  },
  data() {
    return {
      datacollection: null
    };
  },
  methods: {}
};
</script>
<style >
.wemail-sites-overview {
  margin: 30px;
  min-height: 100vh;
}
.wemail-overview-content {
  padding: 15px;
  background: #fafafa;
}
.wemail-overview-content table {
  border: 1px solid #e8e8e8;
}
.wemail-tabs-wrap {
  border: 1px solid #d9d9d9;
}
</style>
